export const downloadPdfBlob = (blobResponse, filename) => {
  const blob = blobResponse instanceof Blob ? blobResponse : blobResponse?.data;

  if (!(blob instanceof Blob)) {
    throw new Error("Không nhận được file PDF từ máy chủ");
  }

  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};
